import { render, staticRenderFns } from "./filter-group.vue?vue&type=template&id=8227578e&scoped=true"
import script from "./filter-group.vue?vue&type=script&lang=js"
export * from "./filter-group.vue?vue&type=script&lang=js"
import style0 from "./filter-group.vue?vue&type=style&index=0&id=8227578e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8227578e",
  null
  
)

export default component.exports